import React from "react";

const URL_REGEX = /(https?:\/\/[^\s]+)/gi;

type LinkifiedTextProps = {
  text?: string;
  className?: string;
  clampLines?: number;
};

export const LinkifiedText: React.FC<LinkifiedTextProps> = ({
  text = "",
  className = "",
  clampLines,
}) => {
  const lines = text.split("\n");
  const clampStyle =
    clampLines && clampLines > 0
      ? {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical" as const,
          WebkitLineClamp: clampLines,
          overflow: "hidden",
        }
      : undefined;

  return (
    <span className={className} style={clampStyle}>
      {lines.map((line, lineIndex) => {
        const parts = line.split(URL_REGEX);
        return (
          <React.Fragment key={`${line}-${lineIndex}`}>
            {parts.map((part, partIndex) => {
              const isUrl = URL_REGEX.test(part);
              URL_REGEX.lastIndex = 0;
              if (!isUrl) {
                return (
                  <React.Fragment key={`${part}-${partIndex}`}>
                    {part}
                  </React.Fragment>
                );
              }

              return (
                <a
                  key={`${part}-${partIndex}`}
                  href={part}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary underline break-all"
                  onClick={(event) => event.stopPropagation()}
                >
                  {part}
                </a>
              );
            })}
            {lineIndex < lines.length - 1 && <br />}
          </React.Fragment>
        );
      })}
    </span>
  );
};

